var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featured"},[_c('div',{staticClass:"trapez"}),_c('span',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.$t('lbl_featured')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }